import { exists } from '@aboutyou/legacy-shared/src/utils/exists'
import { TrackingPageTypeWithId } from '@aboutyou/legacy-tracking-sdk'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { PageTrackingContextProvider } from 'helpers/tracking/PageTrackingContext'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import { useObserver } from 'mobx-react-lite'
import { SearchPageSideNavigation } from 'pages/Search/SearchPageSideNavigation'
import DocumentHead from 'pages/SeoStreamPage/DocumentHead'
import SeoStreamPageProductList from 'pages/SeoStreamPage/SeoStreamPageProductList'
import React, { FC } from 'react'
import { useService } from 'services/utils/context'
import ProductStreamLayout from 'sharedComponents/ProductStream/ProductStreamLayout'
import { useSearchPageStore, useSeoStreamPageStore } from 'store/context'
import { ProductStreamContextProvider } from 'store/sidecar/ProductStreamContext'
import styled from 'styled-components'
import {
  LinkBlock,
  LinkHeader,
  Links,
  StyledLink,
} from 'uiComponents/molecules/StreamSEO/StreamSEO'
import SeoText from './components/SeoText'

const StyledSeoText = styled(SeoText)`
  max-width: 1000px;
  margin: 70px auto;
`

const StyledLinks = styled(Links)`
  max-width: 1000px;
  margin: 0px auto;
`

const SeoStreamPage: FC<{}> = () => {
  const seoStreamPageStore = useSeoStreamPageStore()
  const { seoText, brandIds } = useObserver(() => seoStreamPageStore)
  const { filter, pagination, sorting, category } = useSearchPageStore()
  const isLoading = useSearchPageStore(store => store.streamLoading)
  const { t } = useTranslation()
  const service = useService()

  const brands = useObserver(() =>
    brandIds.map(id => service.brands.getByBrandId(`${id}`)).filter(exists),
  )

  return (
    <>
      <ProductStreamContextProvider
        filterViewStore={filter}
        paginationViewStore={pagination}
        sortingViewStore={sorting}
        categoryViewStore={category}
        pageType={'search'}
      >
        <DocumentHead />
        <ProductStreamLayout
          padded
          navigation={<SearchPageSideNavigation />}
          main={<SeoStreamPageProductList />}
        />
        {!isLoading && seoText && (
          <>
            <StyledSeoText
              hideSeoTitle={true}
              seoText={seoText.replace('h1>', 'h2>')}
            />
          </>
        )}
        {!isLoading && !!brands.length && (
          <StyledLinks>
            <LinkBlock>
              <LinkHeader data-testid="LinkHeader">
                {t('Weiterführende Links')}
              </LinkHeader>
              <ul>
                {brands.map(brand => (
                  <li key={brand.id}>
                    <StyledLink data-testid="Link" to={brand.url}>
                      {t('{{brand}} Online Shop', {
                        brand: brand.name,
                      })}
                    </StyledLink>
                  </li>
                ))}
              </ul>
            </LinkBlock>
          </StyledLinks>
        )}
      </ProductStreamContextProvider>
    </>
  )
}

const TrackedSeoStreamPage: React.FC<{ disableTracking?: boolean }> = ({
  disableTracking,
}) => {
  const { path, search } = useTrackingPageUrl()
  const seoStreamPageStore = useSeoStreamPageStore()
  const id = useObserver(() => seoStreamPageStore.id)

  /**
   * @todo pick pageType from SDK as soon as it's available
   */
  return (
    <PageTrackingContextProvider
      id={Number(id)}
      path={path}
      search={search}
      type={TrackingPageTypeWithId.SeoStreamPage}
      disabled={disableTracking}
    >
      <SeoStreamPage />
    </PageTrackingContextProvider>
  )
}
export default TrackedSeoStreamPage
